import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider, createRouter } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { erstelleQueryClient } from './queryClient'
import { routeTree } from './routeTree.gen'
import './styles/app.css'

// Die Voreinstellungen und die 401-Regel stehen in queryClient.ts, damit die Tests denselben
// Client bauen wie der Browser — eine zweite Kopie hier wäre genau die Drift, die man nicht sieht.
const queryClient = erstelleQueryClient()

const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: 'intent',
})

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

const wurzel = document.getElementById('root')
if (wurzel === null) throw new Error('Im Dokument fehlt das Element #root.')

createRoot(wurzel).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
)
